import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Импортируем переводы
import ru from './ru.json';
import en from './en.json';

const resources = {
  ru: {
    translation: ru,
  },
  en: {
    translation: en,
  },
};

i18n
  .use(LanguageDetector) // Автоматическое определение языка
  .use(initReactI18next) // Инициализация react-i18next
  .init({
    resources,
    fallbackLng: 'ru', // Язык по умолчанию
    debug: import.meta.env.DEV, // Включаем дебаг в dev режиме

    interpolation: {
      escapeValue: false, // React уже экранирует значения
    },

    returnObjects: false, // Отключаем возвращение объектов - используем строки

    detection: {
      // Порядок определения языка
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Ключи для localStorage
      lookupLocalStorage: 'i18nextLng',
      
      // Кэшируем выбранный язык
      caches: ['localStorage'],
    },
  });

export default i18n; 